import styled from 'styled-components';
import { spacing } from '../../../styles/newThemeVariables.styles';

export const Bar = styled.div`
  background-color: ${({ theme }) => theme.border.BorderUnderline};
  width: calc(100% - ${spacing.space32});
  height: ${spacing.space4};
  margin: 0 ${spacing.space16};
  bottom: 0.375rem;
  position: fixed;
  overflow: hidden;
  z-index: 1;
`;

export const Progress = styled.div`
  background-color: ${({ theme }) => theme.border.BorderUnderlineActive};
  height: ${spacing.space4};
  position: absolute;
  width: 100%;
  left: -100%;
`;

export const Container = styled.div``;

export const Content = styled.div``;
